import React, { FC } from 'react'
import { Link } from '@mui/material'
import { Typography } from '@mui/material'
import { routes } from 'config'
import { ModuleHeader, ModuleBody } from 'components'

const LoggedOut: FC = () => (
  <>
    <ModuleHeader title="You have been logged out">
      <ModuleBody>
        <Typography variant="body1">
          Click the logo or return to 
          <Link href={routes.defaultRedirection} target="_self">
            BrightMLS.com
          </Link>
           to log in, access our contact information, or view additional
          information about Bright. 
        </Typography>
      </ModuleBody>
    </ModuleHeader>
  </>
)

export default LoggedOut
